export default {
    paginacion_productos_admin: { page: 1, cantidad: 0, rowsPerPage: 2 },

    //Obtiene todos los productos cuando se ingresa al listado de productos
   
    productos_reporte: [],
    filters_reporte: [],

}